import script from "./TabsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsView.vue?vue&type=script&setup=true&lang=js"

import "./TabsView.vue?vue&type=style&index=0&id=1c414a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c414a7a"]])

export default __exports__